import { atom } from "recoil";

// The chatId currently rendered in the DD mini chat widget
export const openChatIdAtom = atom<string | null>({
  key: "openChatIdState",
  default: null,
});
